module.exports = __webpack_public_path__ + "components/location-subheader/static/background--5-e0ea19b34db1ee64753ddc77b9e3ffb3.jpg";